<div id="map" class="map" [class.map-full]="fullscreen" [class.map-mini]="isMiniApp"></div>
<div #popup class="popup" [hidden]="true"></div>
<div #coord class="coord">{{ mousePosition }}</div>